// extracted by mini-css-extract-plugin
export default {"drawer":"M5irs","anchorHandle":"Ou9Rh","dragAreaContainer":"CD7ru","dragArea":"xRJUO","content":"rkI27"};